export default __webpack_public_path__ + "static/media/Left-Grain.e30db94f.PNG";